<template>
  <div class="pb-16 list-service-orders">
    <v-carousel v-if="true" v-model="service_statistics.carousel" class="checkmotors-slider-stats" hide-delimiters height="230">
      <v-carousel-item>
        <div class="yeep-alerts pb-2">
          <v-img :src="homeImage" class="my-3" contain height="200" />
        </div>
      </v-carousel-item>
      <v-carousel-item>
        <div class="score">
          <div class="rate">
            <v-icon color="white" style="margin-top: -5px; margin-right: 5px">mdi-star</v-icon>
            {{ service_statistics.services_evaluations ? service_statistics.services_evaluations : '-' }} / 5
          </div>
          <div class="rate">{{ service_statistics.services_count ? service_statistics.services_count : '-' }} SERVIÇOS</div>
          <div class="score-text">Média de avaliações (06 meses)</div>
        </div>
      </v-carousel-item>
      <v-carousel-item>
        <div class="score">
          <div class="rate" style="width: 100%">
            <v-icon color="white">mdi-calendar-alert</v-icon> {{ service_statistics.services_late ? service_statistics.services_late : '-' }} SERVIÇOS
          </div>
          <div class="score-text">Serviços em atraso</div>
        </div>
      </v-carousel-item>

      <v-carousel-item>
        <div class="action">
          <div class="rate" style="width: 100%; margin-bottom: 10px">
            <v-checkbox
              :input-value="only_my_services"
              @click="toggleMyServices"
              dark
              class="pa-0 ma-0"
              hide-details
              label="SOMENTE MEUS SERVIÇOS"
            ></v-checkbox>
          </div>
          <div class="rate" style="width: 100%">
            <v-checkbox
              :input-value="app_mode === 'default'"
              @click="toggleAppMode"
              dark
              class="pa-0 ma-0"
              hide-details
              label="VISUALIZAÇÃO SIMPLIFICADA"
            ></v-checkbox>
          </div>
        </div>
      </v-carousel-item>
    </v-carousel>

    <WhatsappIntegrationWidget v-else />

    <div class="mx-5 px-3 mb-8" style="background-color: #f5f5f5; border-radius: 5px">
      <v-row>
        <v-col cols="9" class="pr-0">
          <v-text-field
            v-model="search.term"
            v-debounce:2s="searchServices"
            :disabled="loading"
            label="Pesquisar relatório de serviço"
            placeholder="Placa, cliente ou veículo..."
            outlined
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-btn @click="search_dialog.open = true" color="primary" outlined style="width: 100%; padding: 27px">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
        </v-col>
        <v-col v-if="search.status || search.date || search.term" cols="12" class="pt-0">
          <v-btn @click="resetSearch" :disabled="loading" color="red" elevation="0" class="pa-0 ma-0" outlined block dark> Limpar filtros </v-btn>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-card
        @click="viewServiceOrder(service)"
        v-for="service in list.items"
        :key="service.id"
        elevation="0"
        class="mx-5 mb-5"
        style="border: 1px solid #c5c5c5"
      >
        <v-card-title class="pa-0">
          <v-list-item two-line class="px-3">
            <v-list-item-content>
              <v-list-item-title style="text-transform: capitalize !important">
                <div v-if="service.client" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 5px">
                  {{ service.client.name }}
                </div>
                <div v-else>Cliente não especificado</div>
              </v-list-item-title>
              <v-list-item-subtitle>
                <div v-if="service.vehicle" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 5px">
                  {{ service.vehicle.description }} {{ service.vehicle.year_model }}
                </div>
                <div v-else>Veículo não especificado</div>
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-icon v-if="service.vehicle">
              <img :src="service.vehicle.vehicle_plate_photo_url" style="height: 37px; margin-top: 10px" />
            </v-list-item-icon>
          </v-list-item>
        </v-card-title>
        <v-img
          :src="service.service_order_photos.length > 0 ? getServiceCoverPhoto(service.service_order_photos) : noPhotoImage"
          class="align-end"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)"
          height="200px"
        >
          <div v-if="service.pending_photos.length > 0" class="alert-pending-sync-medias">
            <v-icon color="#fff" class="pr-2">mdi-alert-circle</v-icon> MÍDIAS PENDENTES DE SINCRONIZAÇÃO
          </div>
          <v-list-item class="px-3 white--text pb-3">
            {{ service.description }}
          </v-list-item>
        </v-img>
        <v-card-actions class="px-3">
          <div style="font-size: 14px; margin-top: 1px">
            <v-icon size="20" style="margin-right: 2px; margin-top: -2px">mdi-account-wrench</v-icon> {{ getLastResponsible(service) }}
          </div>
          <v-spacer></v-spacer>
          <v-chip v-if="getServiceStatus(service.status)" :color="getServiceStatus(service.status).color" class="white--text" label>{{
            getServiceStatus(service.status).title
          }}</v-chip>
          <v-chip v-if="service.service_order_evaluations.length > 0" color="warning" class="white--text ml-2 px-2" label
            ><v-icon size="20" class="mr-1">mdi-star</v-icon> {{ getServiceAverage(service.service_order_evaluations[0]) }}</v-chip
          >
        </v-card-actions>
      </v-card>
    </div>
    <div v-if="loading">
      <v-skeleton-loader class="mx-5" type="card" style="border: 1px solid #c5c5c5"></v-skeleton-loader>
    </div>
    <div style="text-align: center" class="mx-5 mb-6">
      <v-btn v-if="search.total_pages > 1 && !loading" @click="nextPageServices()" elevation="0" color="#e7e7e7" style="width: 100%">
        <v-icon>mdi-chevron-double-down</v-icon>
      </v-btn>
    </div>
    <v-dialog v-model="search_dialog.open" scrollable persistent>
      <v-card v-if="search_dialog.open">
        <v-card-title class="px-4" style="text-align: center"> Filtrar por status e data </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4 px-3 pt-1">
          <v-select
            v-model="search_dialog.status"
            :items="search_service_status_list"
            item-text="title"
            item-value="code"
            class="mb-3"
            label="Filtrar por status"
            dense
            outlined
            hide-details
          ></v-select>
          <v-btn v-if="!search_dialog.filter_date" @click="search_dialog.filter_date = true" color="primary" outlined block>
            <v-icon left>mdi-calendar</v-icon>
            Ativar filtro por data
          </v-btn>
          <v-date-picker
            v-if="search_dialog.filter_date"
            v-model="search_dialog.date"
            class="pb-3"
            locale="pt-br"
            color="#48B38B"
            full-width
            range
          ></v-date-picker>
          <v-btn v-if="search_dialog.filter_date" @click="search_dialog.filter_date = false" color="red" outlined block>
            <v-icon left>mdi-close</v-icon>
            Desativar filtro por data
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="resetSearchDialog()"> Cancelar </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="searchServices" color="primary" depressed> Pesquisar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { get, set } from 'idb-keyval';
import Thumbor from 'thumbor-js-url-builder';
import dexieDB from '@/services/dexieService';
import WhatsappIntegrationWidget from '@/components/Home/WhatsappIntegrationWidget';

export default {
  components: {
    WhatsappIntegrationWidget
  },
  data: () => ({
    loading: false,
    app_mode: 'advanced',
    only_my_services: false,
    service_statistics: {
      carousel: 0,
      services_count: null,
      services_evaluations: null,
      services_late: null
    },
    search: {
      status: null,
      date: null,
      term: null,
      page: 1,
      total_pages: null
    },
    search_dialog: {
      open: false,
      status: '*',
      filter_date: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)
    },
    list: {
      total: 0,
      items: []
    }
  }),
  computed: {
    search_service_status_list() {
      const list = [...this.$store.getters['General/organization_status_list']];
      list.unshift({ title: 'Todos', code: '*' });
      return list;
    },
    service_status_list() {
      return this.$store.getters['General/organization_status_list'];
    },
    isMotorcycle() {
      const user = this.$store.getters['Auth/user'];
      if (!user || !user.organization || !user.organization.organization_parameters) return false;
      const param = user.organization.organization_parameters.find((p) => p.code === 'MOTORCYCLE');
      return param ? param.value === 'true' || param.value === 'TRUE' || param.value === true : false;
    },
    isTractor() {
      const user = this.$store.getters['Auth/user'];
      if (!user || !user.organization || !user.organization.organization_parameters) return false;
      const param = user.organization.organization_parameters.find((p) => p.code === 'TRACTOR');
      return param ? param.value === 'true' || param.value === 'TRUE' || param.value === true : false;
    },
    isTruck() {
      const user = this.$store.getters['Auth/user'];
      if (!user || !user.organization || !user.organization.organization_parameters) return false;
      const param = user.organization.organization_parameters.find((p) => p.code === 'TRUCK');
      return param ? param.value === 'true' || param.value === 'TRUE' || param.value === true : false;
    },
    homeImage() {
      /* eslint-disable global-require */
      if (this.isTractor) return require('@/assets/tractor_home.png');
      if (this.isMotorcycle) return require('@/assets/motorcyle_home.png');
      if (this.isTruck) return require('@/assets/truck_home.png');
      return require('@/assets/icons/7.svg');
      /* eslint-enable global-require */
    },
    noPhotoImage() {
      /* eslint-disable global-require */
      if (this.isTractor) return require('@/assets/ads_nophoto_tractor.png');
      if (this.isMotorcycle) return require('@/assets/ads_nophoto_motorcycle.png');
      if (this.isTruck) return require('@/assets/ads_nophoto_truck.png');
      return require('@/assets/ads_nophoto.png');
      /* eslint-enable global-require */
    }
  },
  created() {
    // eslint-disable-next-line no-unneeded-ternary
    this.only_my_services = localStorage.getItem('only_my_services') === 'true' ? true : false;
    this.app_mode = localStorage.getItem('app_mode') || 'advanced';
    this.checkResetMediaBackup();
    this.getServiceOrders();
  },
  methods: {
    checkResetMediaBackup() {
      get('medias_backup_enabled').then((enabled) => {
        if (!enabled) {
          dexieDB.clearServiceOrderPhoto();
          set('medias_backup_enabled', true);
        }
      });
    },
    formatVehiclePlate(veihclePlate) {
      const firstPart = veihclePlate.slice(0, 3);
      const secondPart = veihclePlate.substr(-4);
      return `${firstPart}-${secondPart}`;
    },
    getServiceCoverPhoto(photos) {
      const searchPhotoMain = photos.find((photo) => photo.tag === 'entry_medias_main');
      const searchPhotoFront = photos.find((photo) => photo.tag === 'entry_medias_front');
      const thumbor = new Thumbor('y37r666f2300d9gkf', 'https://thumbnail.checkmotors.net');
      let returnPhoto = '';
      const photoUrl = searchPhotoMain?.photo_url || searchPhotoFront?.photo_url;
      if (photoUrl) {
        returnPhoto = thumbor.setImagePath(photoUrl).resize(0, 348).buildUrl();
      }
      return returnPhoto;
    },
    getServiceStatus(statusRef) {
      const status = this.service_status_list.find((status) => status.code === statusRef);
      return status;
    },
    refreshServiceOrders() {
      this.loading = true;
      this.list.items = [];
      this.search.total_pages = null;
      this.search.page = 1;
      this.getServiceOrders();
      this.getStatistics();
    },
    updateItemList(item) {
      const updateServiceOrder = this.list.items.find((service) => service.id === item.id);
      if (updateServiceOrder) {
        Object.keys(updateServiceOrder).forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(item, key)) {
            updateServiceOrder[key] = item[key];
          }
        });
      }
    },
    resetPendingMedias(serviceOrderId) {
      const updateServiceOrder = this.list.items.find((service) => service.id === serviceOrderId);
      if (updateServiceOrder) {
        updateServiceOrder.pending_photos = [];
      }
    },
    async getServiceOrders() {
      this.loading = true;
      try {
        const response = await this.$http.get('/service_orders', {
          params: {
            term: this.search.term,
            page: this.search.page,
            status: this.search.status,
            date: this.search.date,
            only_my_services: this.only_my_services,
            size: 10
          }
        });
        await this.checkPendingServiceOrderPhoto(response);
      } catch (error) {
        console.error('Failed to load service orders:', error);
      } finally {
        this.loading = false;
      }
    },
    async checkPendingServiceOrderPhoto(response) {
      this.list.total = response.data.totalItems;
      this.search.total_pages = response.data.totalPages;

      const newArray = await Promise.all(
        response.data.rows.map(async (obj) => {
          const pendingPhotos = await dexieDB.checkPendingServiceOrderPhoto(obj.id);
          return {
            ...obj,
            pending_photos: pendingPhotos.filter(({ attempts }) => attempts)
          };
        })
      );

      this.list.items = this.list.items.concat(newArray);
      this.loading = false;
    },
    getStatistics() {
      const self = this;
      self.$http
        .get('/service_orders/statistics', {
          params: {
            only_my_services: self.only_my_services
          }
        })
        .then((response) => {
          this.service_statistics.services_count = response.data.services_count;
          this.service_statistics.services_evaluations = response.data.services_evaluations;
          this.service_statistics.services_late = response.data.services_late;
        });
    },
    viewServiceOrder(service) {
      this.$emit('view', { id: service.id, shouldOpenChat: false });
    },
    searchServices() {
      const self = this;
      if (self.search.term && self.search.term.length > 0 && self.search.term.length < 3) {
        return;
      }
      self.search_dialog.open = false;
      self.search.status = self.search_dialog.status;
      if (self.search_dialog.filter_date) {
        self.search.date = self.search_dialog.date;
      }
      self.loading = true;
      self.list.items = [];
      self.search.total_pages = null;
      self.search.page = 1;
      self.getServiceOrders();
    },
    nextPageServices() {
      const self = this;
      self.loading = true;
      self.search.page += 1;
      self.getServiceOrders();
    },
    closeSearchDialog() {
      this.search_dialog.open = false;
    },
    resetSearch() {
      const self = this;
      self.search.term = null;
      self.search.status = null;
      self.search.date = null;
      self.search.page = 1;
      self.list.items = [];
      self.search.total_pages = null;
      self.resetSearchDialog();
      self.getServiceOrders();
    },
    resetSearchDialog() {
      const self = this;
      self.search_dialog.status = '*';
      self.search_dialog.filter_date = false;
      self.search_dialog.date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
      self.search_dialog.open = false;
    },
    getServiceAverage(evaluation) {
      return ((evaluation.attendance_note + evaluation.indication_note + evaluation.service_note) / 3).toFixed(2);
    },
    getLastResponsible(serviceOrder) {
      return serviceOrder.service_order_responsibles.length > 0
        ? serviceOrder.service_order_responsibles.slice(-1)[0].user.name.split(' ')[0]
        : serviceOrder.created_by_user.name.split(' ')[0];
    },
    toggleAppMode() {
      const valorAtual = localStorage.getItem('app_mode') || 'advanced';

      if (valorAtual === 'default') {
        localStorage.setItem('app_mode', 'advanced');
        this.app_mode = 'advanced';
      } else {
        localStorage.setItem('app_mode', 'default');
        this.app_mode = 'default';
      }

      this.$emit('refresh_app_mode', this.app_mode);
    },
    toggleMyServices() {
      const valorAtual = localStorage.getItem('only_my_services');

      if (valorAtual === 'true') {
        localStorage.setItem('only_my_services', false);
        this.only_my_services = false;
      } else {
        localStorage.setItem('only_my_services', true);
        this.only_my_services = true;
      }

      this.refreshServiceOrders();
    }
  },
  watch: {
    'service_statistics.carousel': {
      handler(index) {
        if (index !== 3 && this.service_statistics.services_evaluations === null) {
          this.getStatistics();
        }
      }
    }
  }
};
</script>

<style lang="scss">
.v-chip {
  font-size: 12px !important;
  height: 31px !important;
}

.alert-pending-sync-medias {
  text-align: center;
  background-color: red;
  color: white;
  font-size: 14px;
  z-index: 999;
  top: 0px;
  position: absolute;
  width: -webkit-fill-available;
  padding: 10px 0px;
}

.checkmotors-slider-stats {
  .v-window__next {
    background: transparent !important;
    margin: 0 6px !important;
  }

  .v-window__prev {
    background: transparent !important;
    margin: 0 6px !important;
  }

  .theme--dark.v-btn.v-btn--icon {
    color: #cfcfcf;
  }
}

.list-service-orders {
  .v-list-item {
    width: 100%;
    min-height: 60px;

    .v-list-item__content {
      padding: 5px 0;
    }

    .v-list-item__icon {
      margin: 0px !important;
      padding-top: 2px !important;
    }
  }

  .score {
    margin: 40px 50px 50px 50px;
    background-color: #48b38b;
    padding: 25px 10px 16px 10px;
    border-radius: 5px;
    transition: all 0.5s;
    animation: pulser 3s infinite;
    overflow: hidden;

    .v-rating {
      float: left;
      text-align: center;
      width: 73%;
    }

    .rate {
      width: 49%;
      background-color: #269169;
      text-align: center;
      float: left;
      padding: 16px;
      color: #fff;
      border-radius: 6px;
      font-size: 13px !important;
      font-weight: 500;

      &:nth-child(2) {
        margin-left: 2%;
      }
    }

    .score-text {
      float: left;
      text-align: center;
      width: -webkit-fill-available;
      margin-top: 16px;
      margin-right: 5px;
      margin-left: 5px;
      padding-top: 16px;
      border-top: 1px solid #26a173;
      color: #fff;
      text-transform: uppercase;
      font-size: 14px;
    }
  }

  .action {
    margin: 40px 50px 50px 50px;
    background-color: #48b38b;
    padding: 15px 10px 16px 10px;
    border-radius: 5px;
    transition: all 0.5s;
    animation: pulser 3s infinite;
    overflow: hidden;

    .theme--dark.v-label {
      font-size: 13px !important;
    }

    .v-rating {
      float: left;
      text-align: center;
      width: 73%;
    }

    .rate {
      width: 49%;
      background-color: #269169;
      text-align: center;
      float: left;
      padding: 16px;
      color: #fff;
      border-radius: 6px;
      font-size: 15px;
      font-weight: 500;
    }
  }
}
</style>
